<template><div><h1 id="personenmerkmale" tabindex="-1"><a class="header-anchor" href="#personenmerkmale"><span>Personenmerkmale</span></a></h1>
<p>Personenmerkmale — Merkmale für Adressen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Merkmale dienen der spezifischen Kennzeichnung einer Adresse im System.</p>
<p>Pfad: <code v-pre>Personen → Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Merkmal</dt>
<dd>Bezeichnung des Merkmals</dd>
<dt>Beschreibung</dt>
<dd>Kurze Beschreibung des Merkmals</dd>
<dt>Wert</dt>
<dd>Wert des Merkmals</dd>
<dt>von</dt>
<dd>Gültigkeit des Merkmals Datum von</dd>
<dt>bis</dt>
<dd>Gültigkeit des Merkmals Datum bis</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


